import { useEffect, useRef, useState } from "react";
import ProfileButton from "./ProfileButton";
import NewTreeButton from "./NewTreeButton";
import TreeList from "./TreeList";
import type { TreeListItemData } from "./TreeListItem";
import "./MobileSidebarMenu.css";
import LogoMark from "../images/LogoMark";

interface MobileSidebarMenuProps {
  onLogout?: () => void;
  onSelectTree?: (id: string) => void;
  onRenameTree?: (id: string) => void;
  onDeleteTree?: (id: string) => void;
  onNewTree?: () => void;
}

/** Mobile replacement for the sidebar: a menu button revealing "Profile" and
 * "Your trees" — the latter opening a slide-in drawer with the full list. */
export default function MobileSidebarMenu({
  onLogout,
  onSelectTree,
  onRenameTree,
  onDeleteTree,
  onNewTree,
}: MobileSidebarMenuProps) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  return (
      <div className="mobile-sidebar-menu" ref={menuRef}>
        <button
            className="mobile-sidebar-menu__trigger"
            type="button"
            aria-label="Open menu"
            aria-expanded={drawerOpen}
            onClick={() => setDrawerOpen((v) => !v)}
        >
          <span/>
          <span/>
          <span/>
        </button>

        {drawerOpen && (
            <div className="tree-drawer">
              <ProfileButton onLogout={onLogout} className={"profile-button"}/>
              <button className="tree-drawer__backdrop" aria-label="Close" onClick={() => setDrawerOpen(false)}/>
              <div className="tree-drawer__panel" role="dialog" aria-modal="true" aria-label="Your trees">
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", paddingRight: 16, paddingBottom: 0}}>
                  <div className="sidebar-header">
                    <LogoMark size={24}/>
                    <p>Eolass</p>
                  </div>
                  <button className="tree-drawer__close" aria-label="Close" onClick={() => setDrawerOpen(false)}>
                    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                      <path
                          d="M0 0 L24 24 M24 0 L0 24"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                      />
                    </svg>
                  </button>
                </div>

                <NewTreeButton
                    onClick={() => {
                      onNewTree?.();
                      setDrawerOpen(false);
                    }}
                />

                <div className="tree-drawer__list">
                  <TreeList
                      onSelectTree={(id) => {
                        onSelectTree?.(id);
                        setDrawerOpen(false);
                      }}
                      onRenameTree={onRenameTree}
                      onDeleteTree={onDeleteTree}
                  />
                </div>
              </div>
            </div>
        )}
      </div>
  );
}